import { useEffect, useState } from 'preact/hooks';
import { getFixedHeaderHeight } from '../utils/layout.ts';

const DEBOUNCE_DELAY = 100;

export default function useFixedHeaderHeight() {
  const [fixedHeaderHeight, setFixedHeaderHeight] = useState<number>(() =>
    import.meta.env.SSR ? 0 : (getFixedHeaderHeight() ?? 0)
  );

  // If there is a mutation within the body, the height of the fixed header is
  // recalculated with a debounce, since the header may change.
  useEffect(() => {
    let timeoutId: number | null = null;

    const observer = new MutationObserver(() => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = window.setTimeout(
        () => setFixedHeaderHeight(getFixedHeaderHeight() ?? 0),
        DEBOUNCE_DELAY
      );
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true
    });

    return () => {
      observer.disconnect();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return fixedHeaderHeight;
}
